import Helpers from "../utils/helpers";

const templateContacts = {
	init() {
		this.events();
	},

	events() {
		$(".contact-form").on("submit", (e) => {
			e.preventDefault();
			const formEl = $(e.currentTarget);

			formEl.addClass("loading");

			formEl.find('[type="submit"]').prop("disabled", true);

			if (Helpers.validate(formEl, false)) {
				grecaptcha.ready(() => {
					grecaptcha
						.execute(Sage.recaptcha_key, { action: "submit" })
						.then((token) => {
							templateContacts.submit(token);
						});
				});
			} else {
				formEl.removeClass("loading");
				formEl.find('[type="submit"]').prop("disabled", false);
			}
		});
	},

	submit(token) {
		const formEl = $(".contact-form");

		formEl.find(".form-status").addClass("hidden");

		// Data.
		const formData = new FormData(formEl[0]);
		formData.append("token", token);

		$.ajax({
			url: Sage.ajaxurl,
			type: "POST",
			data: formData,
			processData: false,
			contentType: false,
		})
			.done((response) => {
				if (response.success) {
					formEl[0].reset();

					if (response.data.redirect) {
						window.location = response.data.redirect;
					}

					formEl.find(".form-status").removeClass("error");
				} else {
					formEl.find(".form-status").addClass("error");
				}

				formEl
					.find(".form-status")
					.text(response.data.message)
					.removeClass("hidden");
			})
			.always(() => {
				formEl.removeClass("loading");
				formEl.find('[type="submit"]').prop("disabled", false);
			});
	},
};

export default templateContacts;
